import { useContext } from 'react';
import { BackendDispatchContext } from '../context/backend-context';
import { useEntityList } from './use-entity-list';

export const useOrganizationList = (filter: {}) => {
  const { asyncActions } = useContext(BackendDispatchContext)

  return useEntityList(filter, 'organization', asyncActions!.loadOrganizationList.bind(asyncActions!))
}